<template>
  <div class="input-container">
    <p>{{ data.title }}</p>
    <div>
      <el-input
        v-model="data.value"
        :type="data.type"
        @input="validation"
        :placeholder="data.inputPlaceholder"
        :disabled="data.disabled"
        :class="{ unavailable: unavailable }"
      ></el-input>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
    unavailable: Boolean,
  },
  methods: {
    validation() {
      this.$emit("validation");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../styles/color_palette.scss";

.input-container {
  padding: 10px 0;
}
</style>
